var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header d-xl-block d-none"},[_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('b-img',{attrs:{"src":_vm.appLogoImage,"alt":"logo","width":"120"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }